// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"74666119","952":"920ca6bb"}[chunkId] + ".chunk.js";
};